// Helpers for the public job-management access guard (T2).
//
// Once the backend `EnforceJobSelfServiceAccess` flag is on, the public job
// endpoints return 401 (anonymous) or 403 (self-service access withdrawn).
// 401 is redirected to login centrally in `baseQueryWithReAuth`; 403 is passed
// through to the pages, which surface this message in-place.

export const ACCESS_REMOVED_MESSAGE = 'Your access to this listing has been removed. '
  + 'Please contact the listing owner or a BevNET administrator if you believe this is a mistake.';

export const LISTING_NOT_FOUND_MESSAGE = 'We could not find this job listing. '
  + 'It may have been removed or deleted, or the link may be incorrect.';

export const LISTING_LOAD_ERROR_MESSAGE = 'We could not load this job listing. '
  + 'Please try again in a moment.';

// RTK Query surfaces errors as a FetchBaseQueryError ({ status, data }) or a
// SerializedError. For `fetchBaseQuery`, `status` is the numeric HTTP code on an
// HTTP error response (string values denote transport errors, e.g. FETCH_ERROR).
// A non-JSON error body (e.g. a plain-text 403) instead surfaces as a
// PARSING_ERROR: `status` is the string and the real HTTP code is `originalStatus`.
// Fall back to it so a plain-text 403/404 is still recognised.
export const getErrorStatus = (error: unknown): number | undefined => {
  if (error && typeof error === 'object') {
    const { status, originalStatus } = error as { status?: number | string; originalStatus?: number };
    if (typeof status === 'number') return status;
    if (typeof originalStatus === 'number') return originalStatus;
  }
  return undefined;
};

export const isForbidden = (error: unknown): boolean => getErrorStatus(error) === 403;

export const isNotFound = (error: unknown): boolean => getErrorStatus(error) === 404;
